import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const HautkrebsPage = () => {
  return (
    <Layout>
      <PageHero
        title="Hautkrebs-Screening: Früherkennung schützt Ihre Haut"
        subtitle="Wir untersuchen Ihre Haut auf verdächtige Veränderungen zur frühzeitigen Erkennung von Hautkrebs."
        backgroundImage="/images/Hautkrebs.webp"
        ctaText="Hautkrebs-Screening buchen"
      />

      <ContentSection
        title="Ihre Haut im professionellen Blick"
        content="Hautkrebs ist heilbar, wenn er frühzeitig erkannt wird. Im Rahmen des Hautkrebs-Screenings untersuchen wir Ihre gesamte Haut auf verdächtige Muttermale oder Veränderungen. Diese Untersuchung ist schmerzfrei und kann entscheidend zur Vorbeugung von Hautkrebs beitragen."
        image="/images/Hautkrebs.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Hautkrebs-Screening in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet Hautkrebs-Screening zur Früherkennung von Hautveränderungen und zur Prävention von Hautkrebs an."
      />

      <CTASection
        title="Schützen Sie Ihre Haut"
        subtitle="Vereinbaren Sie einen Termin für Ihr Hautkrebs-Screening."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default HautkrebsPage;
